import { readWhiteLabelCache } from './whiteLabelCache';
import { DEFAULT_PAGE_TITLE } from '../constants/page';
import { ROLE_ENUM } from '../views/Auth/Login/interfaces/IGoogleUser';

interface IGetCustomPageTitleParams {
  defaultTitle: string;
  userRole?: string;
  currentLanguage?: string;
}

export const getCustomPageTitle = ({ defaultTitle, userRole, currentLanguage }: IGetCustomPageTitleParams): string => {
  if (userRole && userRole !== ROLE_ENUM.STUDENT) {
    return defaultTitle;
  }

  const customTheme: any = readWhiteLabelCache() ?? {};

  const isEnglish = currentLanguage?.startsWith('en');

  if (customTheme?.faviconConfig) {
    const wlTitle = isEnglish ? customTheme.faviconConfig.pageTitleEN : customTheme.faviconConfig.pageTitleES;

    if (defaultTitle === DEFAULT_PAGE_TITLE) {
      return wlTitle || defaultTitle;
    }

    if (wlTitle) {
      const pageParts = defaultTitle.split(' | ');
      const pagePrefix = pageParts[0];

      return `${pagePrefix} | ${wlTitle}`;
    }
  }

  return defaultTitle;
};
